import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserSubscriptionService {
  private readonly apiUrl = `${environment.apiUrl}/user-subscriptions`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Marks the user's expired subscription as inactive in the database.
   * Called by the auth interceptor after receiving 403 + SUBSCRIPTION_EXPIRED,
   * before refreshing the token.
   * Always resolves — never throws — so a failure here doesn't block the
   * token refresh that follows.
   */
  async deactivateExpired(): Promise<void> {
    try {
      await firstValueFrom(
        this.http.post<void>(`${this.apiUrl}/deactivate-expired`, {})
      );
    } catch {
      // Non-blocking: the token refresh and role downgrade must still proceed
      // even if this call fails (e.g. already deactivated, network blip).
    }
  }
}